/**
 * Service Worker registration/update failures that are expected in browsers
 * (race, aborted update, invalid transitional state) and should not alert.
 */
const isBenignServiceWorkerError = (error: unknown): boolean => {
  if (!error) {
    return false;
  }

  const maybeError = error as { name?: unknown; message?: unknown };
  const name = typeof maybeError.name === 'string' ? maybeError.name : '';
  const message =
    typeof maybeError.message === 'string' ? maybeError.message : String(error);

  if (
    (name === 'InvalidStateError' || name === 'AbortError') &&
    /ServiceWorker/i.test(message)
  ) {
    return true;
  }

  if (message === 'Rejected' || message === 'Error: Rejected') {
    return true;
  }

  if (/Failed to (update|register) a ServiceWorker/i.test(message)) {
    return true;
  }

  return false;
};

export { isBenignServiceWorkerError };
